import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[pgsPrintHost]',
})
export class PrintDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
